// React imports
import React, { cloneElement, Component } from "react";

// React Admin imports
import { MenuItemLink, translate } from "react-admin";

// Material imports
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import { withStyles } from "@material-ui/core/styles";

// Icon imports
import ExpandMore from "@material-ui/icons/ExpandMore";
import SettingsIcon from "@material-ui/icons/Settings";

import COLORS from "../colors";
import { menuItemStyles } from "./MenuElem";

const styles = theme => ({
  appBar: {
    backgroundColor: "#fff",
    borderBottom: `1px solid ${COLORS.border}`,
    color: COLORS.text
  },
  toolbar: {
    justifyContent: "space-between",
    minHeight: 64,
    padding: "0 16px"
  },
  logo: {
    display: "block",
    height: 40
  },
  userButton: {
    minHeight: 44,
    padding: "4px 8px 4px 6px",
    borderRadius: 12,
    color: COLORS.text,
    textTransform: "none",
    "&:hover": {
      backgroundColor: COLORS.hover
    }
  },
  avatar: {
    display: "flex",
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    width: 34,
    height: 34,
    borderRadius: "50%",
    backgroundColor: COLORS.primary,
    color: "#fff",
    fontSize: 13,
    fontWeight: 700
  },
  userName: {
    marginLeft: 10,
    fontSize: 14,
    fontWeight: 600,
    [theme.breakpoints.only("xs")]: {
      display: "none"
    }
  },
  chevron: {
    marginLeft: 4,
    color: COLORS.muted
  },
  userMenu: {
    marginTop: 6,
    borderRadius: 12,
    border: `1px solid ${COLORS.border}`,
    boxShadow: "0 12px 24px rgba(10, 40, 70, 0.2)"
  },
  menuItem: menuItemStyles.root,
  menuItemActive: menuItemStyles.active
});

export const getInitials = name =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join("");

class CustomAppBar extends Component {
  state = { anchorEl: null };

  openUserMenu = event => this.setState({ anchorEl: event.currentTarget });

  closeUserMenu = () => this.setState({ anchorEl: null });

  render() {
    const { classes, logout, translate } = this.props;
    const { anchorEl } = this.state;
    // authProvider stores these on login; the identity in redux isn't filled
    // with them until the next route change
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userFullName") || "";

    return (
      <AppBar className={classes.appBar} position="static" elevation={0}>
        <Toolbar className={classes.toolbar}>
          <img className={classes.logo} src="/images/logo.png" alt="Klima team" />

          <div>
            <Button
              className={classes.userButton}
              onClick={this.openUserMenu}
              aria-label={translate("ra.auth.user_menu")}
              aria-owns={anchorEl ? "menu-appbar" : null}
              aria-haspopup="true"
            >
              <span className={classes.avatar}>{getInitials(userName)}</span>
              <span className={classes.userName}>{userName}</span>
              <ExpandMore className={classes.chevron} />
            </Button>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              open={!!anchorEl}
              onClose={this.closeUserMenu}
              classes={{ paper: classes.userMenu }}
            >
              <MenuItemLink
                to={`/profile/${userId}`}
                primaryText={translate("pos.profile")}
                leftIcon={<SettingsIcon />}
                onClick={this.closeUserMenu}
                classes={{
                  root: classes.menuItem,
                  active: classes.menuItemActive
                }}
              />
              {logout && cloneElement(logout, { className: classes.menuItem })}
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

export default translate(withStyles(styles)(CustomAppBar));
